import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

export default function Button(props) {
  const { label, outline } = props;
  return (
    <button
      type="button"
      {...props}
      className={`${outline ? 'custom-button--outline' : 'custom-button'}`}>
      {label}
    </button>
  );
}

Button.defaultProps = {
  outline: undefined,
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  outline: PropTypes.string,
};
